  feature = {
    img_selector: ".w-logos img",
    paragraph_selector: ".w-paragraphs p"
  };

  let $logos;
  let $paragraphs;
  let currentIndex = 0;
  let interval;
  
  // Init
  feature.init = function()
  {
    let $logos = $(feature.img_selector);
    let $paragraphs = $(feature.paragraph_selector);

    // Click event
    $logos.on("click", function () {
      let index = $logos.index(this);
      showLogo(index);
      startAutoplay(); // reset timer
    }); 

    function showLogo(index) {
      let $activeLogo = $logos.eq(index);
      let targetClass = $activeLogo.data("target");

      // Update opacity
      $logos.css("opacity", 0.4);
      $activeLogo.css("opacity", 1);

      // Show correct paragraph
      $paragraphs.hide();
      $("." + targetClass).fadeIn(400);

      currentIndex = index;
    }

    function startAutoplay() {
      clearInterval(interval);
      interval = setInterval(function () {
        currentIndex = (currentIndex + 1) % $logos.length;
        showLogo(currentIndex);
      }, 8000); // 8 seconds
    }

    showLogo(0);
    startAutoplay();
  }
